import { render, staticRenderFns } from "./EmployeeNew.vue?vue&type=template&id=02032672"
import script from "./EmployeeNew.vue?vue&type=script&lang=ts"
export * from "./EmployeeNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports